import { isVueRouterHistoryScrollSnapshot } from './isVueRouterHistoryScrollSnapshot';

const PATCHED_KEY = '__baslerBfcacheScrollStatePatched';

type HistoryWithPatchFlag = History & {
  [PATCHED_KEY]?: boolean;
};

/**
 * vue-router saves scroll position in a pagehide handler via history.replaceState.
 * That pattern evicts the page from the back/forward cache (IgnoreEventAndEvict).
 *
 * @see https://github.com/vuejs/router/issues/2631
 */
export function patchHistoryReplaceStateForBfcache(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const historyRef = window.history as HistoryWithPatchFlag;
  if (historyRef[PATCHED_KEY]) {
    return;
  }

  const originalReplaceState = historyRef.replaceState.bind(historyRef);
  let isPageHideEvent = false;

  window.addEventListener(
    'pagehide',
    () => {
      isPageHideEvent = true;
    },
    true
  );

  window.addEventListener(
    'pageshow',
    () => {
      isPageHideEvent = false;
    },
    true
  );

  historyRef.replaceState = (
    state: unknown,
    title: string,
    url?: string | URL | null
  ) => {
    if (isPageHideEvent && isVueRouterHistoryScrollSnapshot(state)) {
      return;
    }

    originalReplaceState(state, title, url);
  };

  historyRef[PATCHED_KEY] = true;
}
